import { Popover } from 'components-antd';
import { Icons, ICON_VARIANT_TYPE } from 'pages/Workshop/Forms/Icons';

import styles from './styles.module.scss';
import { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Divider } from 'antd';

export interface MessageDataProps {
  id: number;
  name: string;
  avatar: string;
}

interface FormUserDropdownProps {
  messageData?: MessageDataProps;
  allowResend?: boolean;
  allowReplace?: boolean;
  allowRemove?: boolean;

  allowMessage?: boolean;

  onResend?: () => void;
  onReplace?: () => void;
  onRemove?: () => void;
  onViewForm?: () => void;
  onMessage?: (messageData: MessageDataProps) => void;
  selectedFormProcess?: number;
  formProcessDocumentId?: number;
  isVoid?: Boolean;
  className?: string;
  resendText?: string;
  emailAddresss?: string;
  shouldHide?: boolean;
}

export const FormUserDropdown = ({
  messageData,
  allowResend,
  allowReplace,
  allowRemove,
  allowMessage,
  onResend,
  onReplace,
  onRemove,
  onMessage,
  className,
  resendText,
  emailAddresss,
  shouldHide,
}: FormUserDropdownProps) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (shouldHide && open) {
      setOpen(false);
    }
  }, [shouldHide, open]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(emailAddresss || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2s
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const getDropdownContent = () => {
    return (
      <div className={styles.popoverOptions}>
        {emailAddresss && (
          <Fragment>
            <div className={styles.emailOptionItem}>
              <div className={styles.emailLabel}>Email Address: </div>
              <div className={styles.emailText}>{emailAddresss}</div>
            </div>

            <Divider className={styles.emailDivider} />

            <div className={styles.optionItem} onClick={handleCopy}>
              <span className={styles.optionIcon}>
                <Icons variant={ICON_VARIANT_TYPE.COPY} />
              </span>
              <span>{copied ? 'Copied!' : 'Copy Email Address'}</span>
            </div>
          </Fragment>
        )}

        {allowResend && (
          <div className={styles.optionItem} onClick={() => onResend && onResend()}>
            <span className={styles.optionIcon}>
              <Icons variant={ICON_VARIANT_TYPE.RESEND} />
            </span>
            <span>{resendText || 'Resend'}</span>
          </div>
        )}

        {allowMessage && (
          <div
            className={styles.optionItem}
            onClick={() => onMessage && messageData && onMessage(messageData)}
          >
            <span className={styles.optionIcon}>
              <Icons variant={ICON_VARIANT_TYPE.MESSAGE} />
            </span>
            <span>Message</span>
          </div>
        )}

        {allowReplace && (
          <div
            className={styles.optionItem}
            onClick={() => {
              setOpen(false);
              onReplace && onReplace();
            }}
          >
            <span className={styles.optionIcon}>
              <Icons variant={ICON_VARIANT_TYPE.REPLACE} />
            </span>
            <span>Replace</span>
          </div>
        )}

        {allowRemove && (
          <p onClick={() => onRemove && onRemove()}>
            <span className={styles.optionIcon}>
              <Icons variant={ICON_VARIANT_TYPE.REMOVE} />
            </span>
            <span>Remove</span>
          </p>
        )}
      </div>
    );
  };

  return (
    <Popover
      content={getDropdownContent()}
      className={classNames(styles.formUserPopover, className)}
      trigger="click"
      placement="bottomRight"
      getPopupContainer={(e) => e}
      open={open}
      overlayClassName={styles.entityOptionsDropDown}
      onOpenChange={(visible) => setOpen(visible)}
    >
      <div className={styles.icon}>
        <Icons variant={ICON_VARIANT_TYPE.MENU_DOTS_BG} />
      </div>
    </Popover>
  );
};
